// Our support contact, shown to clients: the home page's support panel and the setup gate's support line.
export const SUPPORT_EMAIL = 'Operations@CuratedPlanet.com';
